var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-0 elevation-4",class:{
    'rounded-xl': !_vm.showFileViewerCol,
    'rounded-lg': _vm.showFileViewerCol,
  },attrs:{"flat":"","color":"white"}},[_c('fileViewerWrapper',{attrs:{"openedFile":_vm.fileToShow,"filesGroupedByCard":_vm.filesGroupedByCard,"fullscreen":_vm.fullscreen},on:{"close":_vm.close,"toggleFullscreen":function($event){_vm.fullscreen = !_vm.fullscreen}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }